import { BaseEntityInfoUtils, EntityInfo } from '@record-it-npm/synchro-common';
import { AppCommonSynchronizationEnvironmentTypes } from '../../../AppCommonSynchronizationEnvironment';
import { EntityName } from '../../../EntityName';
import { CreateEntityInfoOptions } from '../../base/CreateEntityInfoOptions';
import { UserGroupSubEntityInfoUtils } from '../../base/UserGroupSubEntityInfoUtils';
import { TimeTrackingActivityCompilationDto } from './TimeTrackingActivityCompilationDto';
export function createTimeTrackingActivityCompilationEntityInfo<TEntity extends TimeTrackingActivityCompilationDto>(options: CreateEntityInfoOptions<TimeTrackingActivityCompilationDto, TEntity>): EntityInfo<AppCommonSynchronizationEnvironmentTypes, EntityName.TimeTrackingActivityCompilation, TEntity> {
  return {
    entityName: EntityName.TimeTrackingActivityCompilation,
    synchronizeRelativeTo: [],
    trackGlobalRevision: true,
    fieldInfos: BaseEntityInfoUtils.createFieldInfos<AppCommonSynchronizationEnvironmentTypes, TimeTrackingActivityCompilationDto, TEntity>({
      ...UserGroupSubEntityInfoUtils.createBaseFieldInfos(),
      name: {
        name: 'name',
        defaultValue: ''
      }
    }, options.additionalFieldInfos)
  };
}